import styled from "styled-components";
import React, {FC} from "react";
import {Typography} from "antd";
import {formatDate} from "../../../utils/helpers/dateHelpers/dateHelpers";
import {useAppSelector} from "../../../store/store";
import {IChatUser} from "../../../store/reducers/chatReducer/chatReducer";

interface IChatStrangerMessage {
  messageText: string;
  sendDate?: Date;
  fromUser?: IChatUser;
  showSenderName?: boolean;
}

const ChatStrangerMessageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-right: 16px;
  box-sizing: border-box;
`;

const ChatStrangerMessageStyled = styled.div<{isFromCompanyMember?: boolean}>`
  border-radius: 5px;
  padding: 5px 10px;
  background: ${props => props.isFromCompanyMember ? '#f0e6ff' : 'transparent'};
  border: 1px solid ${props => props.isFromCompanyMember ? '#b37feb' : '#d9d9d9'};
  width: fit-content;
  text-align: left;
`;

const SenderName = styled.div`
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #666;
`;

export const ChatStrangerMessage: FC<IChatStrangerMessage> = ({messageText, sendDate, fromUser, showSenderName}) => {
  const {offset} = useAppSelector(state => state.user.oneItemObject.item.timezone) || {offset: 0};

  const getSenderName = () => {
    if (!fromUser || !showSenderName) {
      return null;
    }
    
    const parts = [fromUser.firstName, fromUser.middleName, fromUser.lastName].filter(Boolean);
    return parts.join(' ') || 'User';
  };

  const senderName = getSenderName();

  return (
    <ChatStrangerMessageWrapper>
      {senderName && <SenderName>{senderName}</SenderName>}
      <ChatStrangerMessageStyled isFromCompanyMember={showSenderName}>
        <Typography style={{color: showSenderName ? '#722ed1' : 'inherit'}}>{messageText}</Typography>
      </ChatStrangerMessageStyled>
      <div style={{fontSize: 9}}>{sendDate && formatDate(sendDate, offset)}</div>
    </ChatStrangerMessageWrapper>
  );
};